var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons/Navigation/Lock"),React.createElement("g",{"id":"icons/Navigation/Lock","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},[React.createElement("rect",{"id":"Rectangle","stroke":"#FFFFFF","strokeWidth":"2","x":"5","y":"11","width":"15","height":"10","rx":"1","key":0}),React.createElement("path",{"d":"M8,7 L8,3.61538462 C8,3.27551708 8.44771525,3 9,3 L16,3 C16.5522847,3 17,3.27551708 17,3.61538462 L17,11","id":"Path","stroke":"#FFFFFF","strokeWidth":"2","key":1})])]);
}

Lock.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Lock;

Lock.default = Lock;
